(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hauck-dealer-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const formId = 'HauckDealerForm';
    const maxAge = 30 * 60 * 1000;

    function storageKey(form) {
      return 'hauck:dealer:v1:' + document.documentElement.lang + ':' + new URL(form.action).pathname;
    }

    function fields(form) {
      return Array.from(form.elements).filter((field) =>
        field.name.startsWith('contact[') && !field.disabled &&
        ['text', 'email', 'tel', 'textarea', 'select-one', 'checkbox'].includes(field.type)
      );
    }

    function clearSaved(form) {
      try { sessionStorage.removeItem(storageKey(form)); } catch {}
    }

    function saveSubmitted(form) {
      try {
        sessionStorage.setItem(storageKey(form), JSON.stringify({
          savedAt: Date.now(),
          values: fields(form).map((field) => ({
            name: field.name,
            type: field.type,
            value: field.value,
            checked: field.type === 'checkbox' && field.checked
          })),
          expanded: Boolean(form.querySelector('details.optional-details[open]'))
        }));
      } catch {}
    }

    function restoreSubmitted() {
      const form = document.getElementById(formId);
      if (!form) return;
      if (form.querySelector('[data-hauck-dealer-success]')) {
        clearSaved(form);
        return;
      }
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey(form)));
        if (!saved) return;
        const age = Date.now() - saved.savedAt;
        if (!Number.isFinite(age) || age < 0 || age > maxAge || !Array.isArray(saved.values)) {
          clearSaved(form);
          return;
        }
        let restored = false;
        fields(form).forEach((field) => {
          const item = saved.values.find((value) => value && value.name === field.name && value.type === field.type);
          if (!item || typeof item.value !== 'string') return;
          if (field.type === 'checkbox') {
            if (!field.checked && item.checked === true && item.value === field.value) {
              field.checked = true;
              restored = true;
            }
          } else if (!field.value && item.value) {
            if (field.type === 'select-one' && !Array.from(field.options).some((option) => option.value === item.value)) return;
            field.value = item.value;
            restored = true;
          }
        });
        if (restored) {
          const details = form.querySelector('details.optional-details');
          if (details && saved.expanded) details.open = true;
          const notice = form.querySelector('[data-hauck-dealer-restored]');
          if (notice) notice.hidden = false;
        }
      } catch { clearSaved(form); }
    }

    document.addEventListener('focusout', (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;
      if (event.target.form?.id === formId && event.target.required && event.target.type === 'text') {
        event.target.value = event.target.value.trim();
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.id !== formId) return;
      fields(form).forEach((field) => {
        if (field.required && field.type === 'text') field.value = field.value.trim();
      });
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      saveSubmitted(form);
    }, true);

    document.addEventListener('reset', (event) => {
      if (event.target instanceof HTMLFormElement && event.target.id === formId) clearSaved(event.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restoreSubmitted, { once: true });
    } else {
      restoreSubmitted();
    }
    document.addEventListener('shopify:section:load', restoreSubmitted);
  })();
  } catch(e) { console.error(e); }
})();

})();
